import {
  TextField,
  Select,
  OutlinedInput,
  MenuItem,
  Box,
  Autocomplete,
} from "@mui/material/";
import formInputs from "../formInputs";
import countries from "../countries.js";
import { useState } from "react";
import timeZoneArray from "../timeZoneArray";

const Personal = ({ userData, handleUserChange, setUserData }) => {


  const handleUserThing = (e, selected) => {
    console.log(selected)
    // setUserData((prev) => ({ ...prev, country: selected }));
  };

  return (
    <div className="personal">
      {userData.mentorType === "Mentor" ? (
        <>
          
          <p>First name</p>
          <TextField
            name="firstName"
            required
            value={userData.firstName}
            onChange={handleUserChange}
          />

          <p>Last name</p>
          <TextField
            name="lastName"
            required
            id="outlined-required"
            value={userData.lastName}
            onChange={handleUserChange}
          />

          <p>Email address</p>
          <TextField
            name="email"
            required
            id="outlined-required"
            value={userData.email}
            onChange={handleUserChange}
          />

          <p>Your pronouns</p>
          <Select
            name="pnoun"
            required
            // exclusive
            className="pronoun"
            // labelId="pronoun"
            value={userData.pnoun}
            onChange={handleUserChange}
            input={<OutlinedInput label="pronoun" />}
          >
            {formInputs.pronouns.map((item) => (
              <MenuItem
                name="pnoun"
                // fullWidth
                className="menus"
                key={item.id}
                value={item.name}
              >
                {item.name}
              </MenuItem>
            ))}
          </Select>

          <p>Your country</p>
          <TextField
            name="country"
            required
            value={userData.country}
            onChange={handleUserChange}
          />

          <p>Your time zone</p>
          <TextField
            name="timeZone"
            required
            value={userData.timeZone}
            onChange={handleUserChange}
          />
        </>
      ) : null}

      {/* mentees below */}

      {userData.mentorType === "Mentee" ? (
        <>
          <p>First name</p>
          <TextField
            name="firstName"
            required
            value={userData.firstName}
            onChange={handleUserChange}
          />

          <p>Last name</p>
          <TextField
            name="lastName"
            required
            id="outlined-required"
            value={userData.lastName}
            onChange={handleUserChange}
          />

          <p>Email address</p>
          <TextField
            name="email"
            required
            id="outlined-required"
            value={userData.email}
            onChange={handleUserChange}
          />

          <p>Your pronouns</p>
          <Select
            name="pnoun"
            required
            className="pronoun"
            value={userData.pnoun}
            onChange={handleUserChange}
            input={<OutlinedInput label="pronoun" />}
          >
            {formInputs.pronouns.map((item) => (
              <MenuItem
                name="pnoun"
                className="menus"
                key={item.id}
                value={item.name}
              >
                {item.name}
              </MenuItem>
            ))}
          </Select>

          

          {/* <p>Country:</p>
          <Autocomplete
            value={userData.country}
            onChange={handleUserThing}
            name="country"
      
            options={countries}
            autoHighlight
            getOptionLabel={(option) => option.label}
            renderOption={(props, option) => (
              <Box
                component="li"
                style={{ gap: "1rem" }}
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <span className="countryFlag">
                  <img
                    loading="lazy"
                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                    alt=""
                  />
                </span>
                {option.label} ({option.code})
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            )}
          /> */}

          <p>Your country</p>
          <TextField
            name="country"
            required
            // timeZoneArray
            value={userData.country}
            onChange={handleUserChange}
          />

          <p>Time zone</p>
          <TextField
            name="timeZone"
            required
            // timeZoneArray
            value={userData.timeZone}
            onChange={handleUserChange}
          />
        </>
      ) : null}
    </div>
  );
};

export default Personal;
